import { Component } from '@angular/core';
import { TranslocoModule } from '@jsverse/transloco';
import { InfoCardComponent } from '../featureInfoCard/featureInfoCard';
import { infoCards }        from '../featureInfoCard/featureInfoCardInterface';

@Component({
  selector: 'app-features-section',
  standalone: true,
  imports: [TranslocoModule, InfoCardComponent],
  templateUrl: './features-section.html',
  styles: [`:host { display: block; }`],
})
export class FeaturesSectionComponent {
  infoCards = infoCards;
}
